import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Navigation from "@/components/landing/Navigation";
import HeroSection from "@/components/landing/HeroSection";
import PainPointsSection from "@/components/landing/PainPointsSection";
import ValueProposition from "@/components/landing/ValueProposition";
import HowItWorks from "@/components/landing/HowItWorks";
import ServicesGrid from "@/components/landing/ServicesGrid";
import EcommerceSection from "@/components/landing/EcommerceSection";
import PricingSection from "@/components/landing/PricingSection";
import ComparisonSection from "@/components/landing/ComparisonSection";
import SavingsCalculator from "@/components/landing/SavingsCalculator";
import FAQSection from "@/components/landing/FAQSection";
import AuditFormSection from "@/components/landing/AuditFormSection";
import Footer from "@/components/landing/Footer";
import StickyMobileCTA from "@/components/landing/StickyMobileCTA";
import WhatsAppWidget from "@/components/landing/WhatsAppWidget";
import CookieBanner from "@/components/landing/CookieBanner";
import UseCaseSimulator from "@/components/landing/UseCaseSimulator";
import UrgencyBanner from "@/components/landing/UrgencyBanner";
import CookiePolicyPage from "@/components/landing/CookiePolicyPage";
import PrivacyPolicyPage from "@/components/landing/PrivacyPolicyPage";
import AcademyLandingPage from "@/components/landing/AcademyLandingPage";
import KnowledgeCenterPage from "@/components/landing/KnowledgeCenterPage";

import { useEffect } from "react";

const LandingPage = () => {
  useEffect(() => {
    document.title = "OKontainers | Importaci\u00f3n, Log\u00edstica y Aduanas para Empresas";
    const setMeta = (name, content, prop) => {
      const attr = prop ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", "Externalizamos tu departamento de compras y log\u00edstica internacional. Gesti\u00f3n de proveedores, transporte, aduanas y seguimiento completo.");
    setMeta("og:title", "OKontainers | Importaci\u00f3n, Log\u00edstica y Aduanas para Empresas", true);
    setMeta("og:description", "Externalizamos tu departamento de compras y log\u00edstica internacional. Gesti\u00f3n de proveedores, transporte, aduanas y seguimiento completo.", true);
    // Canonical
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) { canon = document.createElement("link"); canon.setAttribute("rel", "canonical"); document.head.appendChild(canon); }
    canon.setAttribute("href", "https://okontainers.com/");
  }, []);

  return (
  <>
    <Navigation />
    <main>
      <HeroSection />
      <PainPointsSection />
      <UseCaseSimulator />
      <ValueProposition />
      <HowItWorks />
      <ServicesGrid />
      <EcommerceSection />
      <PricingSection />
      <ComparisonSection />
      <SavingsCalculator />
      <FAQSection />
      <AuditFormSection />
    </main>
    <Footer />
    <StickyMobileCTA />
    <WhatsAppWidget />
    <CookieBanner />
    <UrgencyBanner />
  </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/cookies" element={<CookiePolicyPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/academias" element={<AcademyLandingPage />} />
            <Route path="/aprende" element={<KnowledgeCenterPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
